import React from 'react'

const ResumeCard = ({badge,title,subtitle,des}) => {
  return (
    <div className='w-full py-6 flex flex-col gao-2.5 border-b-[1px] border-b-zinc-600 shadow-lg shadow-green-600'>
        {
            badge===""?<h6 className='w-28 text-center text-md py-[1px] text-designColor border-[1px] border-designColor rounded-md'>
            2020-Present
        </h6>:
        <h6 className='w-24 text-center text-md py-[1px] text-[#999] border-[1px] border-zinc-800 rounded-md'>
        {badge}
    </h6>
        }
        
        <h2 className='text-lg font-titleFont text-textColor font-medium py-2'>
            {title}
        </h2>
        <p className='text-sm text-[#999] -mt-2'> {subtitle}</p>
        <p className='text-base text-[#999] font-medium pr-10'>{des}</p>

    </div>
  )
}

export default ResumeCard